// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.buttonStack {
    justify-content: flex-end;
    flex-shrink: 0;
}

.dialogFullScreen {
    max-height: initial;
}

.fullScreenButton {
    position: absolute;
    top: 0px;
    right: 0px;
    width: 24px;
}`, "",{"version":3,"sources":["webpack://./src/app/workflow/workflow.dialog.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,WAAW;AACf","sourcesContent":[".buttonStack {\n    justify-content: flex-end;\n    flex-shrink: 0;\n}\n\n.dialogFullScreen {\n    max-height: initial;\n}\n\n.fullScreenButton {\n    position: absolute;\n    top: 0px;\n    right: 0px;\n    width: 24px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
